@if (control && control.invalid && control.dirty && control.touched && !control.hasError('nothingSelected')) {
  <div class="validation-message p-2 text-danger">
    <fa-icon [icon]="['fas', 'exclamation-triangle']" class="align-middle me-1"></fa-icon>
    @if (customMessage) {
      {{ customMessage }}
    }
    @if (!customMessage) {
      @if (control.hasError('zorgMinutenTeVeel')) {
        {{ control.errors['zorgMinutenTeVeel'].bericht }}
      }
      @if (control.hasError('zorgMinutenIncompleet')) {
        {{ control.errors['zorgMinutenIncompleet'].bericht }}
      }
      @if (control.hasError('somTeHoog')) {
        {{ control.errors['somTeHoog'].bericht }}
      }
      @if (control.hasError('maxTotaal')) {
        {{ control.errors['maxTotaal'].bericht }}
      }
      @if (control.hasError('required')) {
        Veld is verplicht
      }
      @if (control.hasError('max')) {
        Maximale waarde is {{ control.errors['max'].max }}
      }
      @if (control.hasError('min')) {
        Minimale waarde is {{ control.errors['min'].min }}
      }
      @if (control.hasError('maxlength')) {
        Maximaal aantal karakters is {{ control.errors['maxlength'].requiredLength }}
      }
      @if (control.hasError('minlength')) {
        Minimaal aantal karakters is {{ control.errors['minlength'].requiredLength }}
      }
      @if (control.hasError('customUrl')) {
        Ongeldige url
      }
      @if (control.hasError('customVideoUrl')) {
        {{ control.errors['customVideoUrl'].message }}
      }
      @if (control.hasError('email')) {
        Ongeldig e-mailadres
      }
      @if (control.hasError('customEmail')) {
        Ongeldig e-mailadres
      }
      @if (control.hasError('customPhone')) {
        Ongeldig telefoonnummer
      }
      @if (control.hasError('customDutchZipcode')) {
        Ongeldige postcode
      }
      @if (control.hasError('customPassword')) {
        {{ control.errors['customPassword'].message }}
      }
      @if (control.hasError('customDateComparison')) {
        {{ control.errors['customDateComparison'].message }}
      }
      @if (control.hasError('customTimeComparison')) {
        {{ control.errors['customTimeComparison'].message }}
      }
      @if (control.hasError('customNumberComparison')) {
        {{ control.errors['customNumberComparison'].message }}
      }
      @if (control.hasError('ngbDate')) {
        Ongeldige datum
      }
      @if (control.hasError('ngbTime')) {
        Ongeldige tijd
      }
      @if (control.hasError('customOneFieldRequired')) {
        {{ control.errors['customOneFieldRequired'].message }}
      }
      @if (control.hasError('customValidation')) {
        {{ control.errors['customValidation'].message }}
      }
    }
    <!-- {{ control.errors | json }} -->
  </div>
}
@if (control && control.invalid && control.hasError('nothingSelected')) {
  <div class="validation-message p-2 text-danger">
    <fa-icon [icon]="['fas', 'exclamation-triangle']" class="align-middle me-1"></fa-icon>
    @if (control.hasError('nothingSelected')) {
      Veld is verplicht
    }
  </div>
}
